import { render } from "./index.vue?vue&type=template&id=119852ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=119852ce&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/yang/yiwu-commodity-wms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119852ce"]])

export default __exports__